module.exports = __webpack_public_path__ + "b0f4b280b9a1bf9665c455048516aaa0.pdf";